import { render, staticRenderFns } from "./BackToList.vue?vue&type=template&id=e336adec"
import script from "./BackToList.vue?vue&type=script&lang=js"
export * from "./BackToList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports